/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Paused_Banner_DescriptionInputs */



/**
* | output |
* | --- |
* | "Members can't access it, connector syncs are stopped, and AI responses won't use its files. Reactivate to restore access." |
*
* @param {Spaces_Paused_Banner_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_paused_banner_description = /** @type {((inputs?: Spaces_Paused_Banner_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Paused_Banner_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mitglieder haben keinen Zugriff, Connector-Synchronisationen sind gestoppt und KI-Antworten nutzen die Dateien nicht. Reaktiviere, um den Zugriff wiederherzustellen.")
	return /** @type {LocalizedString} */ ("Members can't access it, connector syncs are stopped, and AI responses won't use its files. Reactivate to restore access.")
});